import { BASE } from './index';
import axios from './http';
const borrowMoney = {
    // 借钱列表
    categorieslist: params => axios.post(`${BASE.PRO1}/LoanAd/getLoanAdList`, params ),
    // 删除列表
    deleteinfo: params => axios.post(`${BASE.PRO1}/product/delete/info`, params ),
    // 恢复默认
    deletereset: params => axios.post(`${BASE.PRO1}/product/delete/reset`, params ),
    // 借钱点击列表
    getGuideRecord: params => axios.post(`${BASE.PRO1}/LoanAd/getGuideRecord`, params ),
    // 借钱删除
    setDelLine: params => axios.post(`${BASE.PRO1}/LoanAd/setDelLine`, params ),
    // 借钱新增编辑
    buildData: params => axios.post(`${BASE.PRO1}/LoanAd/buildData`, params ),
    
 
};

export default borrowMoney;
